export default "__VITE_ASSET__B5Fgu_l3__"